module.exports = __webpack_public_path__ + "img/p-02.634a4368.webp";